export { default as LoyaltyLinksWidget } from './loyalty-links-widget';
